import React, { useState } from "react";
import CommonDropdownInput from "../common/inputs/CommonDropdownInput";
import PointsCreateRewardModal from "../modal/points/PointsCreateRewardModal";
import { pointsConfig } from "../../pointsConfig";

function PointsRewardsHeader({ callback, value, onFilterChange }) {
  const [modal, setModal] = useState(false);
  const filterOptions = [
    { label: "All", code: "all" },
    ...Object.values(pointsConfig.rewardCreation.rewardTypes),
  ];
  return (
    <div className="w-full flex items-center justify-between mb-4">
      <PointsCreateRewardModal
        open={modal}
        setOpen={setModal}
        callback={callback}
      />
      <div className="max-w-[200px] w-full">
        <CommonDropdownInput
          placeholder="Filter by type"
          options={filterOptions}
          optionObject
          value={value}
          onChange={onFilterChange}
        />
      </div>
      <button
        className="font-bold text-white text-sm px-10 h-12 flex items-center justify-center rounded-md bg-primary1"
        onClick={() => setModal(true)}
      >
        Create
      </button>
    </div>
  );
}

export default PointsRewardsHeader;
